/*
 *   File : manage-goal.js
 *   Author : https://evoqins.com
 *   Description : manage goal component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle, setSearchEnabled } from "../../Redux/Ui/ui.slice";
import { PrimaryButton } from "../../Components/Buttons";
import { GoalCard } from "../../Components/Cards";
import { useNavigate } from "react-router-dom";
import { APIService } from "../../Service";
import { EmptyScreen, Loader } from "../../Components/Other";

export default function ManageGoal() {
  const [loader, setLoader] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [goals, setGoals] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    _getGoals();
    dispatch(setPageTitle(["Manage Goal"]));
    dispatch(setSearchEnabled(false));
  }, []);

  //service to get goal list
  const _getGoals = () => {
    setLoader(true);
    APIService(false, "goal/list")
      .then((res) => {
        if (res.status_code === 200) {
          console.log(res);
          setGoals(res.data);
        } else {
          setIsEmpty(true);
        }
      })
      .catch(() => {
        setGoals([]);
        setIsEmpty(true);
      })
      .finally(() => setLoader(false));
  };

  return loader ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column row-gap-3 pt-3">
      <div className="d-flex justify-content-end">
        <PrimaryButton
          name={"Add Goal"}
          ClassName={
            "bg-oxford-blue fw-400 fs-16 lh-24 text-white rounded-16 py-2 px-3"
          }
          onPress={() => {
            navigate("/manage-goal/add");
          }}
        />
      </div>
      {isEmpty ? (
        <EmptyScreen message={"No goals found"} />
      ) : (
        <div className="d-flex flex-column e-glass-card rounded-24 shadow-none p-24 bg-transparent row-gap-3">
          <h3 className="fw-500 fs-14 lh-20 text-black mb-0">Goals</h3>
          <div className="row row-cols-4 rg-14">
            {goals.map((goal, index) => {
              return (
                <div key={index} className="col">
                  <GoalCard
                    onClick={() =>
                      navigate(`/manage-goal/detail/${goal.goal_style_id}`)
                    }
                    title={goal.name}
                    img={goal.image}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
